
import axios from 'axios';
import { UserManager } from 'oidc-client-ts';
import oidcConfig from '../utils/Authconfig';
import { STORAGE_KEY } from '../utils/Constant';
import { initializeFaro } from '../otel/otel-config';
 
const faro = initializeFaro();
const userManager = new UserManager(oidcConfig);
const user = await userManager.getUser();
const BACKEND_API_URL = "https://nonprod-apim-dev-kshema-2.azure-api.net/translate"
 
 
const getAuthData = () => {
    const data = localStorage.getItem(STORAGE_KEY.AUTH_DATA);
    return JSON.parse(data);
}; 
export const getAllFiles = async () => {
    const span = faro.api?.startSpan?.('getAllFiles');
    const url1 = `${BACKEND_API_URL}/files`;
    const { accessToken, refreshToken } = getAuthData();
 
    try {
        faro.api.pushLog(['📡 Calling getAllFiles API']);
 
        const response = await axios.get(url1, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                refresh_token: `${refreshToken}`,
            },
        });
 
        faro.api.pushLog(['✅ Successfully fetched files']);
        span?.end?.();
        return response.data;
    } catch (error) {
        faro.api.pushLog(['❌ Error fetching files']);
        span?.recordException?.(error);
        span?.setStatus?.({ code: 2, message: error.message }); // 2 = ERROR
        span?.end?.();
        throw error;
    }
};
 
 
export const translateFileAPI = async (file, sourceLang, targetLang) => {
    const span = faro.api?.startSpan?.('translateFileAPI');
    const { accessToken, refreshToken } = getAuthData();
 
    const formData = new FormData();
    formData.append('files', file);
    formData.append('source_language', sourceLang);
    formData.append('target_language', targetLang);
 
    try {
        faro.api.pushLog([
            '📤 Uploading file for translation',
        ]);
 
        const response = await axios.post(`${BACKEND_API_URL}/files/`, formData, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                refresh_token: `${refreshToken}`,
            },
        });
 
        faro.api.pushLog([
            '✅ File uploaded and translation initiated',
        ]);
 
        span?.end?.();
        return response.data;
    } catch (error) {
        faro.api.pushLog([
            '❌ Error uploading file for translation',
        ]);
        span?.recordException?.(error);
        span?.setStatus?.({ code: 2, message: error.message }); // 2 = ERROR
        span?.end?.();
        throw error;
    }
};
 

export const getTranslatedFiles = async (file_id) => {
    const span = faro.api?.startSpan?.('getTranslatedFiles');
    const { accessToken, refreshToken } = getAuthData();

    try {
        const originalUrl = `${BACKEND_API_URL}/files/file_id=${file_id}?type=original`;
        const translatedUrl = `${BACKEND_API_URL}/files/file_id=${file_id}?type=translated`;

        faro.api.pushLog(['📥 Fetching original file', { file_id, url: originalUrl }]);

        const originalResponse = await axios.get(originalUrl, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                refresh_token: `${refreshToken}`,
            },
            responseType: 'blob',
        });

        faro.api.pushLog(['📥 Fetching translated file', { file_id, url: translatedUrl }]);

        const translatedResponse = await axios.get(translatedUrl, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                refresh_token: `${refreshToken}`,
            },
            responseType: 'blob',
        });

        faro.api.pushLog(['✅ Successfully fetched both original and translated files']);
        span?.end?.();

        return {
            original: {
                data: originalResponse.data,
                type: 'original',
            },
            translated: {
                data: translatedResponse.data,
                headers: translatedResponse.headers, 
                type: 'translated',
            },
        };
    } catch (error) {
        faro.api.pushLog(['❌ Error fetching translated files']);
        span?.recordException?.(error);
        span?.setStatus?.({ code: 2, message: error.message });
        span?.end?.();
        throw error;
    }
};
 


 
 
export const deleteFiles = async (file_id) => {
    const span = faro.api?.startSpan?.('deleteFiles');
    const { accessToken, refreshToken } = getAuthData();
    const url = `${BACKEND_API_URL}/files/file_id=${file_id}`;
 
    try {
        faro.api.pushLog(['🗑️ Attempting to delete file']);
 
        const response = await axios.delete(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                refresh_token: `${refreshToken}`,
            },
        });
 
        faro.api.pushLog(['✅ File deleted successfully']);
        span?.end?.();
        return response.data;
    } catch (error) {
        faro.api.pushLog(['❌ Error deleting file']);
        span?.recordException?.(error);
        span?.setStatus?.({ code: 2, message: error.message });
        span?.end?.();
        throw error;
    }
};
 

 
 
export const getLanguagesList = async () => {
    const span = faro.api?.startSpan?.('getLanguagesList');
    const { accessToken, refreshToken } = getAuthData();
    const url = `${BACKEND_API_URL}/languages`;
 
    try {
        faro.api.pushLog(['🌐 Fetching list of supported languages', { url }]);
 
        const response = await axios.get(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                refresh_token: `${refreshToken}`,
            },
        });
 
        faro.api.pushLog(['✅ Successfully fetched languages list']);
        span?.end?.();
        return response.data;
    } catch (error) {
        faro.api.pushLog(['❌ Error fetching languages list']);
        span?.recordException?.(error);
        span?.setStatus?.({ code: 2, message: error.message });
        span?.end?.();
        throw error;
    }
};

export const retryTranslateFile = async (file_id) => {
    const span = faro.api?.startSpan?.('getAllFiles');
    const url7 = `${BACKEND_API_URL}/files`;
    const { accessToken, refreshToken } = getAuthData();
 
    try {
        faro.api.pushLog(['📡 Calling getAllFiles API']);

        const formData1 = new FormData();
        formData1.append('file_id', file_id);
 
        const response = await axios.patch(url7, formData1,{
            headers: {
                Authorization: `Bearer ${accessToken}`,
                refresh_token: `${refreshToken}`,
            },
        });
 
        faro.api.pushLog(['✅ Retry to translate the file files']);
        span?.end?.();
        return response.data;
    } catch (error) {
        faro.api.pushLog(['❌ Error Translating files']);
        span?.recordException?.(error);
        span?.setStatus?.({ code: 2, message: error.message }); // 2 = ERROR
        span?.end?.();
        throw error;
    }
};
 

// --- NEW DOWNLOAD HELPER FUNCTIONS ---

// Function to download a file from a given URL
export const downloadFileFromUrl = (url, filename) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = filename; // Set the desired filename
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Function to download a file from a Base64 string
export const downloadFileFromBase64 = (base64, filename, mimeType) => {
  const byteCharacters = atob(base64); // Decode base64 string
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mimeType }); // Create a Blob from the byte array
  const url = URL.createObjectURL(blob); // Create a temporary URL for the Blob

  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url); // Clean up the URL object to free up memory
};
